import axios from './BaseService'

const ENDPOINT = `${process.env.REACT_APP_API_URL}/lotteries`

export async function getLotteries(token, page, limit, status) {
  const endPoint = `${ENDPOINT}/listlotteries${page ? `?page=${page}` : ''}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.post(endPoint, { status, limit }, { headers })
  return response.data
}

export async function getLottery(token, id) {
  const endPoint = `${ENDPOINT}/lottery/${id}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.get(endPoint, { headers })
  return response.data
}

export async function getTimezone(token) {
  const endPoint = `${ENDPOINT}/timezones`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.get(endPoint, { headers })
  return response.data
}

export async function doEditLottery(token, post) {
  const endPoint = `${ENDPOINT}/editlottery/${post.id}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.put(endPoint, post, { headers })
  return response.data
}

export async function createLottery(token, post) {
  const endPoint = `${ENDPOINT}/addlottery`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.post(endPoint, post, { headers })
  return response.data
}

export const editImg = async (token, id, data) => {
  const endPoint = `${ENDPOINT}/picture/${id}`
  const headers = { Authorization: `${token}` }
  const response = await axios.post(endPoint, data, { headers })
  return response.data
}

export async function createGamePackage(token, post) {
  const endPoint = `${ENDPOINT}/addgamepackage`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.post(endPoint, post, { headers })
  return response.data
}

export async function doEditGamePackage(token, post) {
  const endPoint = `${ENDPOINT}/editgamepackage/${post.id}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.put(endPoint, post, { headers })
  return response.data
}

export async function getGamePackages(token, mainLotteryId) {
  const endPoint = `${ENDPOINT}/gamepackages/${mainLotteryId}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.get(endPoint, { headers })
  return response.data
}

export async function createDayAward(token, post) {
  const endPoint = `${ENDPOINT}/adddayaward`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.post(endPoint, post, { headers })
  return response.data
}

export async function doEditDayAward(token, post) {
  const endPoint = `${ENDPOINT}/editdayaward/${post.id}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.put(endPoint, post, { headers })
  return response.data
}

export async function getDayAwards(token, mainLotteryId) {
  const endPoint = `${ENDPOINT}/dayawards/${mainLotteryId}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.get(endPoint, { headers })
  return response.data
}

export async function getResults(token, page, limit, mainLotteryId) {
  const endPoint = `${ENDPOINT}/results${page ? `?page=${page}` : ''}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.post(endPoint, { mainLotteryId, limit }, { headers })
  return response.data
}
